import Invoices from 'modules/Finance/PaymentProfiles/Invoices/Invoices'
import Reducer from 'modules/Finance/PaymentProfiles/Invoices/reducer'

export default Invoices

export { Reducer }
